var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"Ai-Disclaimer grey--text text--darken-1 caption"},[_vm._v(" "+_vm._s(_vm.$t("aiSearch.disclaimerText"))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }